import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as S from './SeoPage.styles';
import SeoSearchHeader from '../SearchPage/components/ModifySearchHeader/ModifySearchHeaderUI';
import SeoPageHeader from './containers/SeoPageHeader/SeoPageHeaderUI';
import SeoContainer from './containers/SeoContainer/SeoContainer';
import SeoInterLinking from './containers/SeoInterLinking/SeoInterLinking';
import Benefits from '../../../stories/components/cars/ResultsPage/Benefits/BenefitsUI';
import { pageView } from '../../config/ga';
import { seoBenefitsDataSelector, seoFormCouponSelector, showLeaveIntentSelector, showSEOLeadgenSelector } from './redux/selector';
import { gcCitySEOScreen, getLoadedComponent } from '../../config/omni';
import { CityPageComp } from '../../utils/util-constants';
import { fetchModalInfoAndPackageDetails } from '../../common/redux/thunks';
import { homeHourlyRentalPackageSelector } from '../../common/redux/selector';
import LeadGenButton from './containers/LeadGenButton/LeadGenButton';
import { getTravellerInformation } from '../Homepage/redux/thunks';
import { travellerDetailsCalledSelector } from '../Homepage/redux/selector';
import TripAssistant from './containers/LeadGenButton/TripAssistant';
import { logEventToXDMWithPage } from 'xdmLogging/fireEventHelpers';

export default function CityPage() {
  const benefitsData = useSelector(seoBenefitsDataSelector);
  const hrPackageDetails = useSelector(homeHourlyRentalPackageSelector)
  const showSEOLeadgen = useSelector(showSEOLeadgenSelector);
  const travellerDetailsCalled = useSelector(travellerDetailsCalledSelector);
  const showLeaveIntent = useSelector(showLeaveIntentSelector);
  const couponData = useSelector(seoFormCouponSelector)
  const [isPageViewCalled, setIsPageViewCalled] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      getLoadedComponent(CityPageComp)
      dispatch(getTravellerInformation())
 

      if (!Object.keys(hrPackageDetails)?.length) {
        dispatch(fetchModalInfoAndPackageDetails())
      }
    } catch (e) {
      console.log("error", e);
    }
  }, []);

  useEffect(() => {
    if (travellerDetailsCalled && !isPageViewCalled) {
      setIsPageViewCalled(true)
      dispatch(pageView(gcCitySEOScreen))
      logEventToXDMWithPage();
    }
  }, [travellerDetailsCalled, isPageViewCalled])

  return (
    <S.SeoWrapper>
      <SeoSearchHeader isSeo />
      <S.PageHeader>
        <SeoPageHeader />
      </S.PageHeader>
      <S.SeoPageWrapper>
        <S.PageRight>
          <SeoContainer />
          <SeoInterLinking />
        </S.PageRight>
        <S.PageLeft>
           <Benefits {...benefitsData} />
        </S.PageLeft>
      </S.SeoPageWrapper>
      <TripAssistant pageName="Seo" showIcon={showSEOLeadgen} showLeaveIntent={showLeaveIntent} coupon={couponData}/>
    </S.SeoWrapper>
  );
}